export const ChartEventDisplayGroups = {
  Assessment: 'Assessment',
  Visit: 'Visit',
  Document: 'Document',
  Order: 'Order'
}

export const TaskPropTypes = {
  RangeDocument: 'RangeDocument',
  SingleDocument: 'SingleDocument'
}